import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { allAularioAction } from '../AularioAction';

const SelectFieldAularioComponent = ({
  onChange,
  value = '',
  data,
  selects = [],
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const aularioStore = Redux.useSelector((state) => state.aulario);

  const [aulario, setAulario] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      aularioStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setAulario(items);
    } else {
      if (data) {
        setAulario(data);
      } else {
        setAulario(aularioStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && aularioStore.all && aularioStore.all.length === 0) {
        await allAularioAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  return aularioStore.laodingAll ? (
    <CircularProgress size={50} thickness={5} />
  ) : (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${CONST.aula.name}`}>
        {CONST.aula.label}
      </InputLabel>
      <Select
        id={CONST.aula.name}
        value={value?.toString()}
        labelId={`label_${CONST.aula.name}`}
        label={CONST.aula.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {aulario.map((el, index) => {
          return (
            <MenuItem key={`aula-${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectFieldAularioComponent;
